import React from 'react';

const TermsOfUse = () => (
  <>
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
      <div className="container py-4">
        <h1 className="fw-bold">Terms of Use</h1>
        <p className="lead" style={{ color: '#cbd5e1' }}>Last updated: January 2025</p>
      </div>
    </section>

    <section className="py-5 bg-white">
      <div className="container py-4" style={{ maxWidth: 800 }}>
        {[
          {
            title: '1. Acceptance of Terms',
            content: 'By accessing and using the EGB Systems & Solutions website, you accept and agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use our website.',
          },
          {
            title: '2. Use of Website',
            content: 'You agree to use this website only for lawful purposes and in a manner that does not infringe the rights of others. You must not misuse our website by introducing viruses or other malicious material.',
          },
          {
            title: '3. Intellectual Property',
            content: 'All content on this website, including text, graphics, logos, and images, is the property of EGB Systems & Solutions, Inc. and is protected by applicable copyright and trademark laws.',
          },
          {
            title: '4. Disclaimer of Warranties',
            content: 'This website is provided on an "as is" basis without any warranties of any kind, either express or implied. EGB Systems does not warrant that the website will be uninterrupted or error-free.',
          },
          {
            title: '5. Limitation of Liability',
            content: 'EGB Systems & Solutions, Inc. shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of this website or its content.',
          },
          {
            title: '6. Changes to Terms',
            content: 'We reserve the right to modify these Terms of Use at any time. Changes will be effective immediately upon posting to the website. Your continued use of the website constitutes acceptance of the revised terms.',
          },
          {
            title: '7. Governing Law',
            content: 'These Terms of Use shall be governed by and construed in accordance with the laws of the State of Connecticut, without regard to its conflict of law provisions.',
          },
          {
            title: '8. Contact Us',
            content: 'For questions about these Terms of Use, contact us at support@egbsystems.com or call 203 653 2741.',
          },
        ].map((section, i) => (
          <div key={i} className="mb-4">
            <h5 className="fw-bold" style={{ color: '#1a56db' }}>{section.title}</h5>
            <p className="text-muted" style={{ lineHeight: 1.8 }}>{section.content}</p>
          </div>
        ))}
      </div>
    </section>
  </>
);

export default TermsOfUse;
